export enum LoginType
{
    HE ="HE",
    AYOBA="AYOBA",
    NORMAL ="NORMAL"
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/logintype.ts